import typeToReducer from 'type-to-reducer';
import get from 'lodash.get';
import uniqBy from 'lodash.uniqby';
import keyBy from 'lodash.keyby';
import * as actions from './actions';

const initialState = {
  assets: [],
  data: {},
  loading: true,
  err: false,
  errMsg: '',
};

const enhanceAssets = (v, idx) => {
  const path = get(v, 'path', '');
  const [, p] = path.split('/v1/metrics/');
  let shortPath = p;

  if (!p) {
    shortPath = `undefined_${idx}`;
  }

  return {
    ...v,
    shortPath,
  };
};

export default typeToReducer(
  {
    [actions.GET_ENDPOINTS]: {
      PENDING: (state) => ({
        ...state,
        loading: true,
      }),
      FULFILLED: (state, action) => {
        const rawData = get(action, 'payload', []);
        // make a list of all assets
        const a = rawData.map((item) => item.assets).reduce((acc, curr) => acc.concat(curr), []);
        const assets = uniqBy(a, 'symbol');

        const enhanced = rawData.map(enhanceAssets);
        const data = keyBy(enhanced, 'shortPath');

        return {
          ...initialState,
          loading: false,
          assets,
          data,
        };
      },
      REJECTED: (state, action) => ({
        ...state,
        loading: false,
        err: true,
        errMsg: action.payload.message,
      }),
    },
  },
  initialState,
);
